<template>
  <div class="position">
    <div :class="msgClass">
      {{ message.message }}
    </div>
  </div>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';

  .position {
    position: fixed;
    width: 100%;
    left: 0;
    top: 5px;
    z-index: $zindex-flash;
  }

  .flash-message {
    text-align: center;
    padding: 0.75em 2em 0.5em 2em;
    border-radius: 4px;
    background-image: linear-gradient(93deg, $darkish-pink, $blue-purple);

    &.error {
      background: $tomato;
    }
  }
</style>

<script>
export default {
  name: 'FlashMessage',
  props: ['message'],
  computed: {
    msgClass () {
      let cls = ['flash-message']
      if (this.message && this.message.type) cls.push(this.message.type)
      return cls
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/FlashMessage.vue